declare namespace $ {

	export class $shm_hitalama_color_dot extends $mol_view {
		transparent( ): boolean
		color( ): string
		attr( ): ({ 
			'shm_hitalama_color_transparent': ReturnType< $shm_hitalama_color_dot['transparent'] >,
		})  & ReturnType< $mol_view['attr'] >
		style( ): ({ 
			'backgroundColor': ReturnType< $shm_hitalama_color_dot['color'] >,
		}) 
	}
	
}

//# sourceMappingURL=dot.view.tree.d.ts.map